import React from 'react'
import { Link } from 'react-router-dom'

function BecomeAsellerBtn() {
    return (
        <>
            <div className="become-a-seller-btn">
                <Link to="/become-a-seller">
                    <button className='btn become-a-seller-btn me-3'>Become a Seller</button>
                </Link>
            </div>
        </>
    )
}

export default BecomeAsellerBtn
